import React, { useState, useEffect } from 'react'
import { Modal, Popover, Button, Empty, Progress, Input } from 'antd'
import { useTranslation } from 'react-i18next'
import { Initial } from 'react-initial'
import { renderToStaticMarkup } from 'react-dom/server'
import i18n from 'i18n'
import classNames from 'classnames'
import { useDispatch } from 'react-redux'
import history from 'history'
import store from 'store'
import { SERVICE_NAME } from 'service'
import { store as reduxStore } from 'index'
import { scheduleClipboardClear, CLIPBOARD_AUTO_CLEAR_ENABLED } from 'utils/clipboardClear'
import {
  DEFAULT_AUTH_PAGE,
  getSearchParamProps,
  setSearchParams,
  encodeNSearch,
  checkPageReplace,
  timeFormat as timeFormatOrigin,
} from 'utils'
import conf, { isKR, isJP } from 'conf'

import { COLORS } from 'pages/records/components/RecordLabel/color'
import CategoriesService from 'api/Categories'
import styles0 from 'pages/records/components/style.module.scss'
import syncAniGIF from '@/assets/images/sync-ani.gif'

import NoRecordIcon from '@/assets/images/icon-no-record.svg'
import NoGroupIcon from '@/assets/images/icon-no-group.svg'
import NoTemplateIcon from '@/assets/images/icon-no-template.svg'
import xCircleBlue22SVG from '@/assets/images/x-circle-blue-22.svg'
import xCircleRed22SVG from '@/assets/images/exclamation-circle-red-22.svg'
import exclamationNavy20SVG from '@/assets/images/exclamation-circle-20.svg'
import exclamationBlack16SVG from '@/assets/images/exclamation-circle-black-16.svg'
import close20SVG from '@/assets/images/icon-close-20.svg'
import duplicateIcon from '@/assets/images/icon-duplicate.svg'
import emptyPersonIcon from '@/assets/images/icon-person-64.svg'
import emptyActivityIcon from '@/assets/images/icon-activity-empty.svg'
import emptyLabelIcon from '@/assets/images/icon-no-label.svg'
import emptyMemberIcon from '@/assets/images/icon-no-group-gray.svg'
import emptyAdminActivityIcon from '@/assets/images/icon-no-support.svg'
import leftIcon from '@/assets/images/arrow-left.svg'
import gridIcon from '@/assets/images/icon-record-grid.svg'
import FrameIcon from '@/assets/images/icon-record-frame.svg'

import styles from './style.module.scss'

export const ICON_MAP = {
  red: xCircleRed22SVG,
  blue: xCircleBlue22SVG,
  navy: exclamationNavy20SVG,
  black: exclamationBlack16SVG,
}

function resolveIcon(icon) {
  if (typeof icon === 'string' && ICON_MAP[icon]) {
    return <img src={ICON_MAP[icon]} alt="icon" />
  }
  return icon
}

export const colors = [
  '#A9624A',
  '#D06B64',
  '#F83A22',
  '#FA573C',
  '#FF7537',
  '#FF950F',
  '#00BB65',
  '#008247',
  '#43A608',
  '#6BBC00',
  '#FFA600',
  '#FFBC0A',
  '#67AC8F',
  '#61BCC4',
  '#7AA4C8',
  '#4986E7',
  '#6D6FDE',
  '#8562D6',
  '#8D8D8D',
  '#AB8E92',
  '#A7767D',
  '#F46594',
  '#F46594',
  '#7446B7',
]

export function stringToHash(s) {
  let h = 0
  for (let i = 0; i < s.length; i += 1) {
    // eslint-disable-next-line no-bitwise
    h = (Math.imul(31, h) + s.charCodeAt(i)) | 0
  }
  return h
}

export function getColorByString(str) {
  const absHash = Math.abs(stringToHash(str))
  return colors[Math.abs(((absHash % colors.length) - 1) % colors.length)]
}

export function getInitialAvatar(name, email) {
  if (name == null && email == null) {
    return null
  }

  const avatarProps = {
    // charCount: 2,
    charCount: 1,
    textColor: '#ffffff',
    height: 40,
    width: 40,
    fontSize: 18,
    fontWeight: 700,
    fontFamily:
      'Pretendard GOV, -apple-system, BlinkMacSystemFont, system-ui, Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR", "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif',
    radius: 0,
  }

  let tmp = []
  if (name != null) {
    tmp = name.split(/[\s\r\n,.]+/gm)
  } else {
    const pos = email.indexOf('@')
    tmp = email.substring(0, pos - 1).split(/[\s\r\n,.]+/gm)
    // const eText = email.substring(pos);
  }

  let str = ''
  tmp.forEach((txt) => {
    if (/^(\p{L}|\d)/gu.test(txt) === true) {
      str += txt.charAt(0)
    }
  })

  str = str.toUpperCase()

  avatarProps.name = str

  // const seed = 0
  // avatarProps.color = colors[Math.floor((str.charCodeAt(0) + seed) % colors.length)]

  avatarProps.color = getColorByString(name || email)

  return <Initial {...avatarProps} />
}

function unicodeCharAt(str, index) {
  const first = str.charCodeAt(index)
  let second

  if (first >= 0xd800 && first <= 0xdbff && str.length > index + 1) {
    second = str.charCodeAt(index + 1)

    if (second >= 0xdc00 && second <= 0xdfff) {
      return str.substring(index, index + 2)
    }
  }

  return str[index]
}

function unicodeSlice(str, start, end, words) {
  let accumulator = ''
  let character
  let stringIndex = 0
  let unicodeIndex = 0
  let nextSpace = -1
  const { length } = str

  // Remove any leading/trailing spaces
  str = str.trim()

  while (stringIndex < length) {
    character = unicodeCharAt(str, stringIndex)

    if (unicodeIndex >= start && unicodeIndex < end) {
      accumulator += character
    } else {
      break
    }

    stringIndex += character.length
    unicodeIndex += 1

    // Find the next space offset from the previous finding
    nextSpace = words ? str.indexOf(' ', nextSpace + 1) : -1
    stringIndex = nextSpace > 0 ? nextSpace + 1 : stringIndex
  }

  return accumulator
}

export function getInitialAvatarSrcByProps(props) {
  const ownProps = {
    name: 'Name',
    color: null,
    seed: 0,
    charCount: 1,
    textColor: '#ffffff',
    height: 40,
    width: 40,
    fontSize: '18px',
    fontWeight: 700,
    fontFamily:
      'Pretendard GOV, -apple-system, BlinkMacSystemFont, system-ui, Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR", "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif',
    radius: 0,
    ...props,
  }

  const {
    width,
    height,
    textColor,
    fontFamily,
    fontSize,
    fontWeight,
    charCount,
    useWords,
    name,
    color,
    seed,
    radius: borderRadius,
  } = ownProps

  let initial = unicodeSlice(name || 'Name', 0, charCount || 1, useWords || false).toUpperCase()
  let backgroundColor =
    color !== null ? color : colors[Math.floor((initial.charCodeAt(0) + seed) % colors.length)]

  if (name.length === 0) {
    initial = ''
    ;[backgroundColor] = colors
  }

  const InitialSvg = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      pointerEvents="none"
      {...{
        width,
        height,
        style: {
          width,
          height,
          backgroundColor,
          borderRadius,
        },
      }}
    >
      <text
        y="50%"
        x="50%"
        dy="0.36em"
        pointerEvents="auto"
        fill={textColor}
        fontFamily={fontFamily}
        textAnchor="middle"
        style={{
          fontSize,
          fontWeight,
          // fontStretch: 'semi-expanded'
        }}
      >
        {initial}
      </text>
    </svg>
  )

  const encodedStr = encodeURIComponent(renderToStaticMarkup(<InitialSvg />)).replace(
    /%([0-9A-F]{2})/g,
    (match, p1) => {
      return String.fromCharCode(`0x${p1}`)
    },
  )

  const imgStr = window.btoa(encodedStr)
  // const imgStr = window.btoa(unescape(encodeURIComponent(renderToStaticMarkup(<InitialSvg />))));
  const svgHtml = `data:image/svg+xml;base64,${imgStr}`

  return svgHtml
}

export function getInitialAvatarSrc(name, email, props) {
  const avatarProps = {
    ...props,
    // charCount: 2,
    charCount: 1,
  }

  if (props == null || props.name == null) {
    if (name == null && email == null && props?.emptyName == null) {
      return null
    }

    let tmp = []
    if (name != null && name.length > 0) {
      tmp = name.split(/[\s\r\n,.]+/gm)
    } else if (email != null && email.length > 0) {
      const pos = email.indexOf('@')
      tmp = email.substring(0, pos - 1).split(/[\s\r\n,.]+/gm)
      // const eText = email.substring(pos);
    } else if (props?.emptyName) {
      tmp.push(props.emptyName)
    }

    let str = ''
    tmp.forEach((txt) => {
      if (/^(\p{L}|\d)/gu.test(txt) === true) {
        str += txt.charAt(0)
      }
    })
    if (str.length === 0) {
      str = '#'
    }

    avatarProps.name = str
  }

  const emptyName = props != null && props.emptyName != null ? props.emptyName : ''

  avatarProps.color = getColorByString(name || email || emptyName)

  return getInitialAvatarSrcByProps(avatarProps)
}

export function getMemberName(member, emailFunc, checkSelf) {
  const myEmail = store.get('app.user.email')

  if (member.email === myEmail && checkSelf !== false) {
    return i18n.t('chat.member.myself')
  }

  if (member.display_name == null) {
    if (emailFunc != null) {
      return emailFunc(member.email)
    }
    return member.email
  }

  return member.display_name
}

export function getEmailName(email) {
  const pos = email.indexOf('@')
  return email.substring(0, pos)
}

export function getDefaultName(member, email, checkSelf) {
  if (member != null) {
    return getMemberName(member, getEmailName, checkSelf)
  }

  return getEmailName(email)
}

export function getMemberInfo(member, email, avatarProps, checkSelf) {
  const name = getDefaultName(member, email, checkSelf)

  let avatarSrc = null
  if (member != null) {
    avatarSrc = member.avatar_url
  }

  if (avatarSrc == null || avatarSrc.trim().length === 0) {
    const avatarName = getDefaultName(member, email, false)
    avatarSrc = getInitialAvatarSrc(avatarName, email, avatarProps)
  }

  return {
    name,
    avatarSrc,
  }
}

// export function getTotalPeopleElem(count) {
//   const totalStr =
//     count === 1
//       ? i18n.t('common.total.one', { count: `<span class='count'>${count}</span>` })
//       : i18n.t('common.total.more', { count: `<span class='count'>${count}</span>` })

//   const totalElem = parse(`<span class='total'>${totalStr}</span>`)
//   return totalElem
// }

// export function getTotalUnitElem(count) {
//   const totalStr =
//     count === 1
//       ? i18n.t('common.totalunit.one', { count: `<span class='count'>${count}</span>` })
//       : i18n.t('common.totalunit.more', { count: `<span class='count'>${count}</span>` })

//   const totalElem = parse(`<span class='total'>${totalStr}</span>`)
//   return totalElem
// }

// export function getTotalAccountElem(count) {
//   const totalStr =
//     count === 1
//       ? i18n.t('common.totalaccount.one', { count: `<span class='count'>${count}</span>` })
//       : i18n.t('common.totalaccount.more', { count: `<span class='count'>${count}</span>` })

//   const totalElem = parse(`<span class='total'>${totalStr}</span>`)
//   return totalElem
// }

function PaginationInfo(options) {
  const {
    name,
    offset,
    limit,
    searchItems,
    useSort,
    // defaultSort,
    onPaginationChange,
    paramNames,
    active,
    subtype,
    dateStart,
    dateEnd,
    showLessItems,
  } = options
  const self = this

  self.name = name
  self.offset = offset
  self.limit = limit
  self.total = 0
  self.active = active
  self.subtype = subtype
  self.dateStart = dateStart
  self.dateEnd = dateEnd
  self.showLessItems = showLessItems
  self.paramNames = {
    valSort: paramNames != null && paramNames.sort != null ? paramNames.sort : 'sort',
    valOrder: paramNames != null && paramNames.order != null ? paramNames.order : 'order',
  }

  const { valSort, valOrder } = self.paramNames

  self.extParams = {}

  self.searchItems = searchItems
  self.searchFilters = {}
  self.sorts = {}

  self.useSort = useSort === true

  self.mount = () => {
    const params = getSearchParamProps()

    let num = 1

    if (params != null) {
      const { page, nsearch } = params
      if (page != null) {
        num = page
      }

      let extParams = {}
      if (nsearch != null) {
        self.searchFilters = {}
        Object.entries(nsearch).forEach(([key, value]) => {
          self.searchFilters[key] = value
        })

        extParams = {
          ...extParams,
          ...self.searchFilters,
        }
      }

      // if (self.useSort === true) {
      //   self.sorts = {}

      //   if (self.sorts[valSort] == null && defaultSort != null) {
      //     Object.entries(defaultSort).forEach(([key, value]) => {
      //       self.sorts[valSort] = key
      //       self.sorts[valOrder] = value === true ? 'asc' : 'desc'
      //     })
      //   }

      //   extParams = {
      //     ...extParams,
      //     ...self.sorts,
      //   }
      // }

      this.setExtParams(extParams)

      if (self.searchFormObj != null) {
        self.searchFormObj.checkParams()
      }
    }

    self.setPage(num, false, false)
  }

  self.checkParams = () => {
    const params = getSearchParamProps()

    let num = 1

    if (params != null) {
      const { page, nsearch, nsort } = params
      if (page != null) {
        num = page
      }

      let extParams = {}
      if (nsearch != null) {
        self.searchFilters = {}
        Object.entries(nsearch).forEach(([key, value]) => {
          self.searchFilters[key] = value
        })

        extParams = {
          ...extParams,
          ...self.searchFilters,
        }
      }

      if (self.useSort === true && nsort != null) {
        self.sorts = {}
        Object.entries(nsort).forEach(([key, value]) => {
          self.sorts[valSort] = key
          self.sorts[valOrder] = value === true ? 'asc' : 'desc'
        })

        extParams = {
          ...extParams,
          // ...self.sorts,
        }
      }

      this.setExtParams(extParams)
    }

    self.setPage(num, false, false)
  }

  self.setExtParams = (params) => {
    self.extParams = params
  }

  self.getReqParam = () => {
    return {
      offset: self.offset,
      limit: self.limit,
      dateStart: self.dateStart,
      dateEnd: self.dateEnd,
      ...self.extParams,
    }
  }

  self.applyRes = (resPagination) => {
    self.offset = resPagination.offset
    self.limit = resPagination.limit
    self.total = resPagination.total
    self.option = resPagination.option
    self.active = resPagination.active
    self.subtype = resPagination.subtype
    self.dateStart = resPagination.dateStart
    self.dateEnd = resPagination.dateEnd
  }

  self.getPagination = () => {
    // 페이지네이션 UI가 표시하는 "현재 페이지"는 실제 리스트 조회에 쓰이는 self.offset 에서만
    // 파생한다. 과거처럼 URL 의 page 파라미터를 우선하면 offset(=실제 로드된 데이터)과 갈라져
    // "UI 는 2페이지인데 리스트는 1페이지" 같은 split-brain 이 생긴다 (openItem 이 setPage 없이
    // URL page 만 바꾸거나, checkPageReplace 가 비활성이라 URL 변경이 재조회를 트리거하지 못하는
    // 경로들 때문). URL page 는 새로고침 복원용(mount 시 setPage 로 offset 에 반영)으로만 쓰고,
    // 화면 표시는 데이터와 동일한 소스(offset)로 고정해 항상 일치시킨다.
    const current = self.limit > 0 ? Math.floor(self.offset / self.limit) + 1 : 1
    const ret = {
      current,
      pageSize: self.limit,
      total: self.total,
      active: self.active,
      subtype: self.subtype,
      dateStart: self.dateStart,
      dateEnd: self.dateEnd,
      showLessItems: self.showLessItems,
      nsort: self.nsort,
      showSizeChanger: false,
    }

    if (self.useSort !== true) {
      ret.onChange = (page, pageSize) => {
        self.limit = pageSize
        // skipRefetch=false: 페이지 변경 시 실제로 재조회한다 (과거 true 라, 이 onChange 를 그대로
        // 쓰는 useSort=false 소비자에선 offset·URL 만 바뀌고 데이터가 갱신되지 않던 잠재 버그)
        self.setPage(page, false, true)
      }
    }

    return ret
  }

  self.getOnChange = () => {
    return async (pagination, filters, sorter, extra) => {
      // console.log(' --- filters: ', filters)
      if (self.useSort !== true) {
        return
      }

      let curPage = 1
      if (pagination != null) {
        const { current, pageSize } = pagination
        curPage = current != null ? current : 1
        self.limit = pageSize
      }

      if (extra.action === 'sort') {
        // const { field, order } = sorter
        // console.log('sorter - ', sorter)
        // const sort = {}
        // const sortMap = {}
        // if (order === 'ascend' || order === 'descend') {
        //   ;[sort[valSort]] = field
        //   sort[valOrder] = order === 'ascend' ? 'asc' : 'desc'
        //   sortMap[sort[valOrder]] = order === 'ascend'
        // } else {
        //   delete self.extParams[valSort]
        //   delete self.extParams[valOrder]
        // }
        // const param = {}
        // setSearchParams(param)
        // this.setExtParams({
        //   ...self.extParams,
        // })
      } else {
        self.setPage(curPage, false, true)
      }
    }
  }

  self.getColumns = (columns) => {
    if (self.useSort !== true) {
      return columns
    }

    const newColumns = []
    columns.forEach((col) => {
      const { dataIndex } = col

      const [sort] = dataIndex
      let sortOrder = null
      if (self.extParams[valSort] === sort) {
        sortOrder = self.extParams[valOrder] === 'desc' ? 'descend' : 'ascend'
      }

      const newCol = {
        ...col,
      }

      if (col.sorter !== false) {
        newCol.sorter = true
        newCol.sortOrder = sortOrder
      }

      newColumns.push(newCol)
    })

    return newColumns
  }

  self.setPage = (page, skipRefetch, useSearchParam) => {
    // page 는 숫자/숫자문자열 모두 올 수 있다. 파싱 실패(NaN)·null·<1 은 1페이지로 정규화하고,
    // 이후 offset·URL·콜백은 모두 정규화된 num 을 쓴다 (원본 page 를 쓰면 비-숫자 문자열에서
    // offset 이 NaN 이 되거나 URL 에 이상값이 박힌다).
    let num = typeof page === 'string' ? parseInt(page, 10) : page
    if (num == null || Number.isNaN(num) || num < 1) {
      num = 1
    }
    self.offset = (num - 1) * self.limit

    if (onPaginationChange != null) {
      if (useSearchParam !== false) {
        const params = {}
        if (num > 1) {
          params[self.name] = num
        } else {
          params[self.name] = undefined
        }

        setSearchParams(params)
      }

      if (skipRefetch !== true) {
        onPaginationChange(num, self.limit, self)
      }
    }
  }

  // for searchForm
  self.getSearchItems = () => {
    return self.searchItems
  }

  // for searchForm
  self.getSearchFilters = () => {
    return self.searchFilters
  }

  self.resetSearch = (/* skipRefetch, extItem */) => {
    Object.keys(self.searchFilters).forEach((key) => {
      if (self.extParams[key] != null) {
        delete self.extParams[key]
      }
    })
    self.searchFilters = {}
  }

  self.checkPageReplace = (props, prevProps) => {
    if (props.location != null && prevProps.location != null) {
      if (checkPageReplace(props.location, prevProps.location) === false) {
        self.checkParams()
      }
    }
  }

  // for searchForm
  self.search = (key, value, preset, skipRefetch, useSearchParam) => {
    self.searchFilters = {}

    const params = {
      nsearch: undefined,
    }

    if (value != null) {
      self.searchFilters[key] = undefined

      if (value.trim().length > 0) {
        self.searchFilters[key] = value
        params.nsearch = encodeURIComponent(encodeNSearch(self.searchFilters))
      }
    }

    const extParams = {
      ...self.extParams,
      ...self.searchFilters,
    }

    self.setExtParams(extParams)

    if (useSearchParam === true) {
      setSearchParams(params)
    }

    // 1페이지 리셋은 "사용자가 실제로 검색/해제(useSearchParam=true)" 하거나 재조회가 동반될 때만.
    // checkParams 의 수동 재동기화(URL 변경마다 호출, skipRefetch=true·useSearchParam=false)에서
    // setPage(1) 을 부르면 offset 이 재조회 없이 0 으로 리셋된다 → 상세/생성 오픈처럼 URL 만 바뀌고
    // 재조회가 없는 경우 "페이지네이션은 1페이지인데 목록은 N페이지" 불일치가 생긴다.
    if (useSearchParam === true || skipRefetch !== true) {
      self.setPage(1, skipRefetch, useSearchParam)
    }

    return true
  }

  self.setSort = (sortField, sortOrder) => {
    if (self.useSort !== true) {
      return
    }

    // sortField가 null이면 order만 변경
    if (sortField === null) {
      if (self.sorts[valOrder] != null) {
        self.sorts[valOrder] = sortOrder || 'desc'
      }
    } else {
      // sortField가 있으면 새로운 정렬 설정
      self.sorts = {}
      self.sorts[valSort] = sortField
      self.sorts[valOrder] = sortOrder || 'desc'
    }

    const extParams = {
      ...self.extParams,
      ...self.sorts,
    }

    self.setExtParams(extParams)
    self.setPage(1, false, true)
  }

  self.getCurrentSort = () => {
    return {
      field: self.sorts[valSort] || null,
      order: self.sorts[valOrder] || null,
    }
  }
}

export function createPaginationInfo(offset, limit, onPaginationChange) {
  return new PaginationInfo(offset, limit, onPaginationChange)
}

export function timeFormat(timeStr, formatStr) {
  const format = formatStr || 'YYYY.MM.DD HH:mm'
  return timeFormatOrigin(timeStr, format)
}

export function confirmBase(options) {
  const opts = {
    title: options.title,
    icon: null,
    closeIcon: options.closeIcon != null ? options.closeIcon : <img src={close20SVG} alt="close" />,
    closable: options.closable,
    width: options.width,
    content: options.content,
    maskTransitionName: options.maskTransitionName,
    okButtonProps: {
      className: classNames('type8', 'h38'),
      style: { minWidth: '100px' },
    },
    cancelButtonProps: {
      className: classNames('h38'),
      style: { minWidth: '100px' },
    },
    open: options.open,
    onOk: options.onOk,
    onCancel: options.onCancel,
    footer: options.footer,
    ...options,
    // 속성을 변경하여 덮어씌우는 경우에는 아래에서 처리.
    wrapClassName: classNames('om-popup-1', options.wrapClassName),
    keyboard: options.maskClosable != null ? options.maskClosable : true,
    maskClosable: options.maskClosable != null ? options.maskClosable : true,
    style: { minWidth: '380px', ...options.style },
    okText: options.okText || i18n.t('common.button.ok'),
    cancelText: options.cancelText || i18n.t('common.button.cancel'),
  }

  if (options.hasIcon === true) {
    opts.icon = <img src={xCircleBlue22SVG} alt="noti" />
  }

  if (options.icon !== undefined) {
    opts.icon = options.icon
  }

  opts.icon = resolveIcon(opts.icon)

  const modal = Modal.confirm(opts)

  return modal
}

// 미저장 변경사항 포기 확인 팝업. Promise<boolean> 반환.
// - true: 사용자가 [Yes] (버림)
// - false: [No] (계속 편집)
// 기존 confirmDiscard({ title, content, submit })와 시그니처가 달라 이름을 분리.
export function confirmDiscardChanges() {
  return new Promise((resolve) => {
    confirmBase({
      icon: 'red',
      title: i18n.t('admin.security.sso.discardChangesTitle'),
      content: i18n.t('admin.security.sso.discardChangesContent'),
      okText: i18n.t('common.button.yes'),
      cancelText: i18n.t('common.button.no'),
      width: 480,
      onOk: () => resolve(true),
      onCancel: () => resolve(false),
    })
  })
}

export function errorBase(options) {
  const opts = {
    wrapClassName: options.wrapClassName || classNames('om-popup-error-1'),
    title: options.title,
    closable: options.closable,
    keyboard: options.maskClosable != null ? options.maskClosable : true,
    maskClosable: options.maskClosable != null ? options.maskClosable : true,
    style: { minWidth: '380px' },
    width: options.width,
    content: options.content,
    okText: options.okText || i18n.t('common.button.ok'),
    okButtonProps: options.okButtonProps || { className: classNames('h38', 'type7', 'w100') },
    maskTransitionName: 'maskTransitionName',
    onOk: options.onOk,
    footer: options.footer,
    onCancel: options.onCancel,
    cancelText: options.cancelText || i18n.t('common.button.cancel'),
    ...options,
  }

  if (options.icon !== undefined) {
    opts.icon = options.icon
  } else {
    opts.icon = <img src={xCircleRed22SVG} alt="error" />
  }

  opts.icon = resolveIcon(opts.icon)

  return Modal.error(opts)
}

export function confirmDelete(options) {
  return confirmBase({
    maskTransitionName: 'maskTransitionName',
    okText: i18n.t('common.button.delete'),
    width: 480,
    okButtonProps: {
      className: classNames('type5', 'h38'),
      style: { minWidth: '100px' },
    },
    cancelButtonProps: {
      className: classNames('h38'),
      style: { minWidth: '100px' },
    },
    ...options,
  })
}

export function confirmDiscard({ title, content, submit }) {
  return confirmDelete({
    icon: 'red',
    title,
    content,
    okText: i18n.t('common.button.ok'),
    onOk: submit,
  })
}

// export function mailApiError(ex) {
//   const e = ex.origin != null ? ex.origin : ex
//   if (e.message != null) {
//     const { code, message, details, desc } = e
//     const title = code != null ? `${message} (${code})` : message
//     let content = ''
//     if (details != null && details.reason != null) {
//       content = details.reason
//     } else if (desc != null) {
//       content = details.desc
//     }
//     errorBase({
//       title,
//       content,
//       width: 450,
//     })
//   } else {
//     errorBase({
//       title: 'Unknown error',
//       content: JSON.stringify(e),
//       width: 450,
//     })
//   }
// }

function popupDoc(options) {
  return confirmBase({
    wrapClassName: classNames(styles.docPopup),
    maskTransitionName: 'maskTransitionName',
    closable: true,
    footer: null,
    width: 896,
    ...options,
  })
}

export function openPrivacy(e) {
  if (e != null) {
    e.stopPropagation()
    e.preventDefault()
  }

  if (isKR()) {
    window.open('https://www.jiransoft.co.kr/privacy', '_blank')
    return
  }

  if (isJP()) {
    window.open('https://jsecurity.co.jp/privacypolicy', '_blank')
    return
  }

  const { language } = i18n

  const SRC = {
    'ko-KR': '/static/SafePassword_privacy_policy_kor.html',
    'en-US': '/static/SafePassword_privacy_policy_eng.html',
    'ja-JP': '/static/SafePassword_privacy_policy_jpn.html',
  }

  popupDoc({
    title: i18n.t('appConfig.label.privacyPolicy'),
    content: (
      <div className={classNames(styles.docScroll)}>
        <iframe
          id="contentFrame"
          title="OfficeMail Privacy Policy"
          src={SRC[language]}
          marginWidth="0"
          marginHeight="0"
          frameBorder="0"
          width="100%"
          height="100%"
          scrolling="yes"
        />
      </div>
    ),
  })
}

export function GridIcon({ isGrid, func = () => {} }) {
  return (
    <Button
      className={styles.Sync}
      onClick={() => {
        func()
        reduxStore.dispatch({
          type: 'settings/SET_IS_GRID',
          payload: {
            isGrid: !isGrid,
          },
        })
      }}
    >
      <img src={isGrid ? FrameIcon : gridIcon} alt="sync" />
    </Button>
  )
}

export function openTerms(e) {
  if (e != null) {
    e.stopPropagation()
    e.preventDefault()
  }

  if (isKR()) {
    window.open('https://www.jiransoft.co.kr/service-policy-next', '_blank')
    return
  }

  const { language } = i18n

  const SRC = {
    'ko-KR': '/static/SafePassword_terms_use_kor.html',
    'en-US': '/static/SafePassword_terms_use_eng.html',
    'ja-JP': '/static/SafePassword_terms_use_jpn.html',
  }

  popupDoc({
    title: i18n.t('appConfig.label.termsOfService'),
    content: (
      <div className={classNames(styles.docScroll)}>
        <iframe
          id="contentFrame"
          title="Safebox Terms of Service"
          src={SRC[language]}
          width="100%"
          height="100%"
        />
      </div>
    ),
  })
}

export function logout() {
  reduxStore.dispatch({
    type: 'user/LOGOUT',
    // 사용자 직접 로그아웃 → 모든 탭으로 전파 (다중 탭 동기 로그아웃)
    payload: { broadcast: true },
  })
}

export function getOfficeNEXTURL(path) {
  const { officeNextURL } = conf

  if (officeNextURL != null && officeNextURL.length > 0) {
    const lang = i18n.language.substring(0, 2)
    const pathStr = path || '/'
    return `${officeNextURL}/${lang}${pathStr}`
  }

  return null
}

export const getCopyFunc = ({ name, value, copyRef }) => {
  const handleCopy = () => {
    let copyText = copyRef ? copyRef.current.getFieldValue(name) : value
    if (copyText == null) {
      copyText = ''
    }

    // 쓰기가 성공한 경우에만 자동삭제 예약(실패 시 예약 안 함). 빈 값이면 예약 안 함.
    // writeText 는 Promise 반환이지만 일부 환경/테스트 mock 은 undefined → Promise.resolve 로 정규화.
    Promise.resolve(navigator.clipboard.writeText(copyText))
      .then(() => {
        if (copyText && CLIPBOARD_AUTO_CLEAR_ENABLED) scheduleClipboardClear()
      })
      .catch(() => {})
  }

  return handleCopy
}

export const CopyPopoverComponent = ({ name, value, copyRef, funcMap, initValue, type }) => {
  const [copy, setCopy] = useState(false)
  const [btnCls, setBtnCls] = useState(initValue != null && initValue.length > 0 ? '' : 'empty')

  if (funcMap != null && name != null) {
    funcMap[name] = {
      setBtnCls,
      getBtnCls: () => btnCls,
    }
  }

  const handleCopy = () => {
    let copyText = copyRef ? copyRef.current.getFieldValue(name) : value
    if (copyText == null) {
      copyText = ''
    }

    // 기존 if(writeText()) 는 Promise 라 항상 truthy 였음 → 쓰기 성공 시에만 처리하도록 체이닝.
    // writeText 반환을 Promise.resolve 로 정규화(실 API Promise + 테스트 mock undefined 모두 대응).
    Promise.resolve(navigator.clipboard.writeText(copyText))
      .then(() => {
        setCopy(true)
        setTimeout(() => setCopy(false), 2000)
        // 클립보드 자동삭제 예약(best-effort). 빈 값이면 예약 안 함.
        if (copyText && CLIPBOARD_AUTO_CLEAR_ENABLED) scheduleClipboardClear()
      })
      .catch(() => {})
  }

  const PopoverContent = () => (
    <Popover
      placement="topRight"
      content={
        type === 'password'
          ? `${i18n.t('workspace.result.copySuccessPassword')}`
          : `${i18n.t('workspace.result.copySuccess')}`
      }
      trigger={copy ? 'hover' : null}
      open={copy}
      onClick={handleCopy}
    >
      <Button
        tabIndex={-1}
        className={classNames('copyPopover', btnCls)}
        type="text"
        icon={<img src={duplicateIcon} alt="duplicate" />}
      />
    </Popover>
  )

  return copyRef ? copyRef.current && <PopoverContent /> : <PopoverContent />
}

export const ExpiresAt = ({ styles2, expiredAt, newExpiredAt, email, type, expiredBoolean }) => {
  const [expired, setExpired] = useState('')
  const expiredFormat = (value) => timeFormat(value, 'YYYY/MM/DD HH:mm')
  const { t } = useTranslation()

  const fetchExpiredDate = () => {
    if (newExpiredAt === 0) {
      setExpired(null)
    } else if (newExpiredAt != null) {
      setExpired(expiredFormat(newExpiredAt))
    } else if (expiredAt != null) {
      setExpired(expiredFormat(expiredAt))
    } else {
      setExpired(null)
    }
  }

  useEffect(() => {
    fetchExpiredDate()

    // eslint-disable-next-line
  }, [newExpiredAt, expiredAt])

  const published = () => {
    switch (type) {
      case 'table':
        return (
          <span className={classNames(styles2.email)}>
            {expired == null ? email : `${t('record.label.expiresDate', { date: expired })}`}
          </span>
        )
      case 'name':
        return (
          <span className={classNames(styles2.expired)}>
            {expiredBoolean ? t('workspace.field.expired') : null}{' '}
          </span>
        )
      case 'dropdown':
        return (
          <span>{expired == null ? t('record.select.expiredDate.noExpiration') : expired}</span>
        )
      default:
        return null
    }
  }

  return published()
}

export const EmptyData = ({
  type,
  className = null,
  expired = false,
  totp = false,
  memo = false,
  shared = false,
}) => {
  let attrs = {}
  const { t } = useTranslation()

  switch (type) {
    case 'record':
      // 메모 탭 빈 상태 — 패스워드 브랜딩 문구(emptyTitle {{service}}) 대신 메모 전용 문구.
      // 인증 코드 탭(totp)·expired 분기와 동형 패턴.
      // shared=true 는 목록 내 소유권 탭의 "공유받은" 탭 — 메모/패스워드 각각 전용 문구.
      if (memo === true && shared === true) {
        attrs = {
          image: NoRecordIcon,
          title: t('record.title.emptySharedMemoTitle'),
          description: t('record.title.emptySharedMemoDesc'),
        }
      } else if (memo === true) {
        attrs = {
          image: NoRecordIcon,
          title: t('record.title.emptyMemoTitle'),
          description: t('record.title.emptyMemoDesc'),
        }
      } else if (shared === true) {
        attrs = {
          image: NoRecordIcon,
          title: t('record.title.emptySharedPasswordTitle'),
          description: t('record.title.emptySharedPasswordDesc'),
        }
      } else if (totp === true) {
        attrs = {
          image: NoRecordIcon,
          // 패스워드 브랜딩 공용 타이틀({{service}} 정보 없음) 대신 전용 타이틀 — 메모 전례 동형
          title: t('record.title.emptyTotpTitle'),
          description: t('record.totp.emptyList'),
        }
      } else if (expired === true) {
        if (isJP()) {
          attrs = {
            image: NoRecordIcon,
            title: t('record.title.emptyExpiredPassword'),
            description: t('record.title.emptyExpiredPasswordDesc'),
          }
        } else {
          attrs = {
            image: NoRecordIcon,
            title: t('record.title.emptyTitle', { service: t(SERVICE_NAME) }),
            description: t('record.title.emptyExpiredRecordDesc', { service: t(SERVICE_NAME) }),
          }
        }
      } else {
        attrs = {
          image: NoRecordIcon,
          title: t('record.title.emptyTitle', { service: t(SERVICE_NAME) }),
          description: t('record.title.emptyDesc', { service: t(SERVICE_NAME) }),
        }
      }

      break
    case 'group':
      attrs = {
        image: NoGroupIcon,
        title: t('group.result.emptyTitle'),
        description: t('group.result.emptyDesc'),
      }
      break
    case 'template':
      attrs = {
        image: NoTemplateIcon,
        title: t('template.title.emptyTitle'),
        description: t('template.title.emptyDesc', { service: t(SERVICE_NAME) }),
      }
      break
    case 'user':
      attrs = {
        image: emptyPersonIcon,
        title: t('email.empty.users'),
        imageStyle: { width: '64px', height: '64px', alignItems: 'center' },
        description: t('email.empty.usersDesc'),
      }
      break
    case 'activity':
      attrs = {
        image: emptyActivityIcon,
        title: t('admin.content.emptyActivity'),
        imageStyle: { width: '64px', height: '64px', alignItems: 'center' },
        description: t('admin.result.emptyActivity'),
      }
      break
    case 'label':
      attrs = {
        image: emptyLabelIcon,
        title: t('record.label.noLabel'),
        imageStyle: { width: '64px', height: '64px', alignItems: 'center' },
        description: t('record.label.noLabelDesc'),
      }
      break
    case 'member':
      attrs = {
        image: emptyMemberIcon,
        title: t('email.empty.members'),
        imageStyle: { width: '64px', height: '64px', alignItems: 'center' },
      }
      break
    case 'admin-activity':
      attrs = {
        image: emptyAdminActivityIcon,
        title: t('admin.result.emptyAdminActivity'),
        imageStyle: { width: '64px', height: '64px', alignItems: 'center' },
      }
      break
    case 'record-shared-group':
      attrs = {
        image: emptyMemberIcon,
        title: t('group.result.emptyTitle'),
        imageStyle: { width: '64px', height: '64px', alignItems: 'center' },
      }
      break
    case 'detail-record-error':
      attrs = {
        image: NoRecordIcon,
        title: t('record.title.emptyTitle', { service: t(SERVICE_NAME) }),
        description: t('workspace.error.noAccessRecord', { service: t(SERVICE_NAME) }),
      }
      break
    default:
      break
  }

  const Published = () => (
    <Empty
      className={classNames('emptyData', type === 'label' && 'labelEmptyData', className)}
      image={attrs.image}
      imageStyle={attrs.imageStyle}
      description={
        <div className={classNames('emptyDataDescription')}>
          <span>{attrs.title}</span>
          <span>{attrs.description}</span>
        </div>
      }
    />
  )

  return <Published />
}

export const PWStrengthElem = ({ strength, value }) => {
  const strengthStr = value || '' ? <span>{passwordStrength({ strength }).text}</span> : null
  return (
    <React.Fragment>
      <Progress
        size={['100%', 4]}
        showInfo={false}
        percent={passwordStrength({ strength }).labels}
        strokeColor={passwordStrength({ strength }).color}
        // height={4}
      />
      {strengthStr}
    </React.Fragment>
  )
}

export const passwordStrength = ({ value, strength }) => {
  const calculate = () => {
    let score = 0
    if (value.length >= 12) score += 2
    else if (value.length >= 8) score += 1

    if (/[a-z]/.test(value)) score += 1

    if (/[A-Z]/.test(value)) score += 1

    if (/[0-9]/.test(value)) score += 1

    if (/[\!@#\$%\^&\*\(\)_\+\~\`\|\₩\"\}\{\[\]:;\'<>,\.\?\\/=\-]/.test(value)) score += 1

    // 연속 문자나 반복 문자 감지 (3번이면 보안 감소)
    if (/([a-zA-Z0-9])\1\1/.test(value)) score -= 1

    // 점수 클램핑 (최소 0, 최대 5)
    score = Math.max(0, Math.min(5, score))

    return score
  }

  const COLOR_LABELS = {
    RED: '#FD4C45',
    ORANGE: '#FF9045',
    GREEN: '#10BF79',
  }

  const strengthData = {
    0: { label: 0, text: i18n.t('record.passwordStrength.veryWeak'), color: COLOR_LABELS.RED },
    1: { label: 20, text: i18n.t('record.passwordStrength.weak'), color: COLOR_LABELS.RED },
    2: { label: 40, text: i18n.t('record.passwordStrength.fair'), color: COLOR_LABELS.ORANGE },
    3: { label: 60, text: i18n.t('record.passwordStrength.strong'), color: COLOR_LABELS.ORANGE },
    4: { label: 80, text: i18n.t('record.passwordStrength.veryStrong'), color: COLOR_LABELS.GREEN },
    5: {
      label: 100,
      text: i18n.t('record.passwordStrength.veryStrong'),
      color: COLOR_LABELS.GREEN,
    },
  }

  return {
    labels: strengthData[strength]?.label || 0,
    text: strengthData[strength]?.text || '',
    color: strengthData[strength]?.color || '#FFFFFF',
    calculate,
  }
}

export function openloadingAni(options) {
  const opts = {
    wrapClassName: classNames('loading-ani-popup'),
    maskTransitionName: 'maskTransitionName',
    icon: null,
    width: 384,
    title: null,
    footer: null,
    content: (
      <div className={classNames('loading-content')}>
        <div className={classNames('loading-ani')}>
          <img src={syncAniGIF} alt="sync" />
        </div>
        <div className={classNames('loading-text')}>{options.text}</div>
      </div>
    ),
  }

  return Modal.confirm(opts)
}

export const LabelContent = ({
  individual,
  reloadRecord,
  deleteIcon,
  reload,
  limit = 5,
  isMyRecord,
}) => {
  const dispatch = useDispatch()
  const RemoveIcon = ({ color = '#000' }) => (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        id="remove"
        d="M1 9L9 1M1 1L9 9"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )

  const handleDeleteLabel = async (labelId) => {
    try {
      const res = await CategoriesService.resourceDelete({
        id: individual.id,
        request: { category_ids: [labelId] },
      })
      if (res.code === 200) {
        reloadRecord()
        reload()
        dispatch({
          type: 'menu/RELOAD',
        })
      }
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <div className={classNames(deleteIcon ? styles0.deleteLabel : styles0.label)}>
      {individual?.categories?.slice(0, limit).map((item) => (
        <React.Fragment key={item.id}>
          <div
            key={item.id}
            style={{
              width: 'max-content',
              background: COLORS.find((color) => color?.value === item.color)?.background,
              color: COLORS.find((color) => color?.value === item.color)?.color,
              border:
                deleteIcon === false &&
                item.color === 'Blue' &&
                store.get('app.settings.isGrid') === true &&
                isMyRecord === true &&
                individual?.is_memo !== true &&
                '1px solid #3362FF',
            }}
          >
            <span style={{ fontSize: 12 }}>{item.name}</span>
            {deleteIcon && (
              <Button
                type="text"
                icon={
                  <RemoveIcon color={COLORS.find((color) => color?.value === item.color)?.color} />
                }
                onClick={() => {
                  handleDeleteLabel(item.id)
                }}
              />
            )}
          </div>
        </React.Fragment>
      ))}
      {individual?.categories?.length > limit && (
        <span>+{(individual?.categories?.length ?? 0) - limit}</span>
      )}
    </div>
  )
}

export const errorTranslationMessage = (errorCode, translate, messageApi) => {
  const error = translate(`workspace.error.${errorCode || 'null'}`)
  return messageApi.open({
    type: 'error',
    content: error,
  })
}

export const logoutConfirm = (func = () => {}) => {
  return confirmBase({
    className: classNames('logoutConfirm'),
    title: i18n.t('logOut.desc.logout'),
    icon: 'blue',
    style: {
      paddingTop: '28px',
    },
    okButtonProps: {
      className: classNames('type6', 'w100', 'h38'),
    },
    onOk: () => {
      reduxStore.dispatch({
        type: 'user/LOGOUT',
        // 사용자 직접 로그아웃 → 모든 탭으로 전파 (다중 탭 동기 로그아웃)
        payload: { broadcast: true },
      })
      history.push(DEFAULT_AUTH_PAGE)
      if (typeof func === 'function') {
        func()
      }
    },
  })
}

export const ArrowLeftIcon = ({ onClick }) => {
  return <Button type="text" icon={<img src={leftIcon} alt="arrow-left" />} onClick={onClick} />
}

export const PasswordInput = ({ ...props }) => {
  const { t } = useTranslation()
  const [isCapsLockOn, setIsCapsLockOn] = useState(false)

  const handlePasswordKeyDown = (e) => {
    const capsLock = e.getModifierState('CapsLock')
    setIsCapsLockOn(capsLock)
  }

  const handlePasswordKeyUp = (e) => {
    const capsLock = e.getModifierState('CapsLock')
    setIsCapsLockOn(capsLock)
  }

  return (
    <React.Fragment>
      <Input.Password {...props} onKeyDown={handlePasswordKeyDown} onKeyUp={handlePasswordKeyUp} />
      {isCapsLockOn && (
        <div className={classNames(styles.capsLockWarning)}>
          ⚠️ {t('login.desc.capsLockOn') || 'Caps Lock is on'}
        </div>
      )}
    </React.Fragment>
  )
}

const uiUtil = {
  getInitialAvatar,
  getInitialAvatarSrcByProps,
  getInitialAvatarSrc,
  getEmailName,
  createPaginationInfo,
  timeFormat,
  confirmDelete,
  openPrivacy,
  openTerms,
  getOfficeNEXTURL,
  CopyPopoverComponent,
  ExpiresAt,
  passwordStrength,
  openloadingAni,
  confirmDiscard,
  LabelContent,
  errorTranslationMessage,
  PWStrengthElem,
  logoutConfirm,
  ArrowLeftIcon,
  GridIcon,
}

export default uiUtil
